export default __webpack_public_path__ + "images/login-mockup@3x.png";